import { inAppChatService } from '@egw/app-chat'
import { Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { type FC } from 'react'

// TODO: WHEN CLOSED DATE IS NOT NULL AND BEING PASSED USED IN TRANSLATION
export const TransferUnavailable: FC /*<{ closeDate: Date }>*/ = () => {
  const { t } = useTranslation('features-transfer')

  // TODO: WHEN CLOSED DATE IS NOT NULL AND BEING PASSED USED IN TRANSLATION
  // const closeDate = date ? formatDateNoTZ(date as unknown as string, t('date.long')) : null

  return (
    <div className="flex flex-col gap-4 h-full">
      <ExclamationCircleIcon className="h-11 w-11 stroke-[1px]" />
      <div className="mb-8">
        <h1 className="text-body text-2xl">{t('transfer.transfer_not_available')}</h1>
        <p className="text-meta text-base">
          {
            // TODO: uncomment this line when closeDate is not null
          }
          {/* {t('transfer.transfer_not_available_description', { closeDate })} */}
          {t('transfer.transfer_not_available_description_wealth')}
        </p>
      </div>
      <Button
        className="md:w-fit"
        variant={ButtonVariant.Secondary}
        onClick={() => {
          inAppChatService.open()
        }}
      >
        {t('client-services.contact_client_services')}
      </Button>
    </div>
  )
}

export default TransferUnavailable
